import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const fallbackCopy = (value) => {
  const textArea = document.createElement("textarea");
  textArea.value = value;
  textArea.setAttribute("readonly", "");
  textArea.style.position = "absolute";
  textArea.style.left = "-9999px";
  document.body.appendChild(textArea);
  textArea.select();
  const copied = document.execCommand("copy");
  document.body.removeChild(textArea);
  return copied;
};

const copyToClipboard = async (value) => {
  if (!value) {
    toast.error(i18n.t("global.toasts.copyError"));
    return false;
  }

  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
    } else {
      const copied = fallbackCopy(value);
      if (!copied) throw new Error("Fallback copy failed");
    }
    toast.success(i18n.t("global.toasts.copySuccess"));
    return true;
  } catch (err) {
    toast.error(i18n.t("global.toasts.copyError"));
    return false;
  }
};

export default copyToClipboard;